module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial1@2x_fdeffa.jpg";